import React, { useState, useEffect } from 'react';
import PageContainer from '../components/containers/PageContainer';
import { IconButton, TableCell, TableRow, Tooltip, Button } from '@mui/material';
import { toast } from 'react-toastify';
import CustomTable from '../components/ui/CustomTable';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import ModalContainer from '../components/containers/ModalContainer';
import env from '../config/env';
import { Link } from 'react-router-dom';
import api from '../config/axios';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import StatusComp from '../components/common/StatusComp';

const LabelPricing = () => {
    const [pricings, setPricings] = useState([]);
    const [message, setMessage] = useState('');
    const [loader, setLoader] = useState('');
    const [lableTypeSwift, setlableTypeSwift] = useState('');
    const [lableName, setlableName] = useState('');
    const [single, setSingle] = useState({});
    const [swiftLabelData, setSwiftLabelData] = useState([]);

    const [showAddLabel, setShowAddLabel] = useState(false);

    const onCloseAddLabelModal = () => {
        setShowAddLabel(false);
    };
    const onOpenAddLabelModal = () => setShowAddLabel(true);

    const [showEditLabel, setShowEditLabel] = useState(false);

    const onCloseEditLabelModal = () => {
        setShowEditLabel(false);
    };
    const onOpenEditLabelModal = () => setShowEditLabel(true);

    const [showDeleteLabel, setShowDeleteLabel] = useState(false);

    const onCloseDeleteLabelModal = () => {
        setShowDeleteLabel(false);
    };
    const onOpenDeleteLabelModal = () => setShowDeleteLabel(true);

    const getPricings = async () => {
        await api
            .get('/labeltype/read')
            .then((res) => {
                setPricings(res.data.labelTypes);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        getPricings();
    }, []);

    const addPricing = async (e) => {
        e.preventDefault();

        setLoader(true);

        const data = {
            name: e.target.name.value,
            uid: e.target.uid.value,
            maxWeight: e.target.maxWeight.value,
            type: e.target.type.value,
            discount: e.target.discount.value,
        };

        await api
            .post('/labeltype/create', data)
            .then((res) => {
                setLoader(false);
                toast.success(res.data.message);
                getPricings();
                onCloseAddLabelModal();
            })
            .catch((err) => {
                setLoader(false);
                toast.error(err.response.data.message);
            });

        setTimeout(() => {
            setMessage('');
        }, 3000);
    };

    const updatePricing = async (e) => {
        e.preventDefault();

        setLoader(true);

        const data = {
            name: single.name,
            uid: single.uid,
            maxWeight: single.maxWeight,
            type: single.type,
            discount: single.discount,
        };

        await api
            .post('/labeltype/update/' + single._id, data)
            .then((res) => {
                setLoader(false);
                toast.success(res.data.message);
                getPricings();
                onCloseEditLabelModal();
            })
            .catch((err) => {
                setLoader(false);
                toast.error(err.response.data.message);
            });

        setTimeout(() => {
            setMessage('');
        }, 3000);
    };

    const enableDisableLabelType = async (id) => {
        await api
            .put('/labeltype/enableDisableLabelType/' + id, {})
            .then((res) => {
                getPricings();
                toast.success(res.data.message);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };

    const DeleteLabelType = async (id) => {
        await api
            .delete('/labeltype/delete/' + id)
            .then((res) => {
                getPricings();
                toast.success(res.data.message);
                onCloseDeleteLabelModal();
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };
    useEffect(() => {
        getSwiftLables();
    }, [lableTypeSwift]);

    const getSwiftLables = async () => {
        try {
            await api
                .get('https://api.swiftlabels.io/api/v2/order/readLabels', {
                    headers: {
                        'x-api-key': env.SWIFT_API_KEY,
                        'content-type': 'application/json',
                    },
                })
                .then((res) => {
                    setSwiftLabelData(res.data.labels);
                })
                .catch((error) => {
                    console.log(error);
                });
        } catch (err) {
            console.log(err);
        }
    };
    return (
        <PageContainer
            title="Label Pricing"
            desc="Set and manage label pricing"
            end={
                <Button onClick={onOpenAddLabelModal} variant="contained">
                    Add Label Type
                </Button>
            }>
            <CustomTable
                sx={{ mt: 2 }}
                fields={['#', 'NAME', 'MAXWEIGHT', 'TYPE', 'UID', 'DISCOUNT', 'STATUS', 'ACTION']}
                dense={false}>
                {pricings.map((pricing, index) => (
                    <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{pricing.name}</TableCell>
                        <TableCell>{pricing.maxWeight}</TableCell>
                        <TableCell>{pricing.type}</TableCell>
                        <TableCell>{pricing.uid}</TableCell>
                        <TableCell>{pricing.discount}%</TableCell>
                        <TableCell>
                            <StatusComp status={pricing.status ? 'active' : 'inactive'} />
                        </TableCell>

                        <TableCell>
                            <Link to={'/labelPricing/' + pricing._id}>
                                <Tooltip title="Manage Pricing">
                                    <IconButton>
                                        <VisibilityOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Link>
                            <IconButton
                                onClick={() => {
                                    setSingle(pricing);
                                    onOpenEditLabelModal();
                                }}
                                title="Edit">
                                <ModeEditOutlineOutlinedIcon fontSize="small" />
                            </IconButton>
                            {pricing.status ? (
                                <Tooltip title="Disable">
                                    <IconButton onClick={() => enableDisableLabelType(pricing._id)}>
                                        <CloseOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            ) : (
                                <Tooltip title="Enable">
                                    <IconButton onClick={() => enableDisableLabelType(pricing._id)}>
                                        <CheckOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            )}
                            <IconButton
                                onClick={() => {
                                    setSingle(pricing);
                                    onOpenDeleteLabelModal();
                                }}>
                                <DeleteOutlineOutlinedIcon fontSize="small" />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                ))}
            </CustomTable>
            {/* create modal */}

            <ModalContainer open={showAddLabel} onClose={onCloseAddLabelModal} hideActions title="Add Label Type">
                {message}
                <form onSubmit={addPricing}>
                    <div className="form-group mb-3">
                        <label>Type</label>
                        <select
                            name="type"
                            id=""
                            className="form-control form-control-sm"
                            onChange={(e) => setlableTypeSwift(e.target.value)}>
                            <option value="" disabled selected hidden>
                                select
                            </option>

                            <option value="aio.gg">aio.gg</option>
                            <option value="swift">swift</option>
                            <option value="u5p5">U5P5</option>
                            <option value="tls">TLS</option>
                            <option value="genemporium">Gen Emporium</option>
                            <option value="bulkup3">Bulkup3</option>
                            <option value="royal_mail">royal_mail</option>
                        </select>
                    </div>
                    {lableTypeSwift === 'swift' ? (
                        <div className="form-group mb-3">
                            <label>Name</label>
                            <select
                                name="name"
                                id=""
                                required
                                className="form-control form-control-sm"
                                onChange={(e) => setlableName(e.target.value)}>
                                <option value="" disabled selected hidden>
                                    select
                                </option>
                                {swiftLabelData?.map((e) => {
                                    return <option value={e.name}>{e.name}</option>;
                                })}
                            </select>
                        </div>
                    ) : (
                        <div className="form-group mb-3">
                            <label>Name</label>
                            <input type="text" className="form-control form-control-sm" name="name" required />
                        </div>
                    )}

                    {lableTypeSwift === 'swift' ? (
                        <div className="form-group mb-3">
                            <label>UID</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                name="uid"
                                required
                                value={
                                    lableTypeSwift === 'swift'
                                        ? swiftLabelData
                                              ?.filter((e) => e.name === lableName)
                                              ?.map((e) => e.uuid.toString())[0]
                                        : ''
                                }
                            />
                        </div>
                    ) : lableTypeSwift === 'u5p5' ? (
                        <div className="form-group mb-3">
                            <label>UID</label>
                            <select
                                name="uid"
                                id=""
                                required
                                className="form-control form-control-sm"
                                onChange={(e) => setlableName(e.target.value)}>
                                <option value="" disabled selected hidden>
                                    select
                                </option>
                                <option value="priority">Priority</option>
                                <option value="express">Express</option>
                                <option value="firstclass">Firstclass</option>
                                <option value="signature">Signature</option>
                            </select>
                        </div>
                    ) : (
                        <div className="form-group mb-3">
                            <label>UID</label>
                            <input type="text" className="form-control form-control-sm" name="uid" required />
                        </div>
                    )}

                    {lableTypeSwift === 'swift' ? (
                        <div className="form-group mb-3">
                            <label>Max Weight</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                name="maxWeight"
                                required
                                value={
                                    lableTypeSwift === 'swift'
                                        ? swiftLabelData
                                              ?.filter((e) => e.name === lableName)
                                              ?.map((e) => e.maxWeight.toString())[0]
                                        : ''
                                }
                            />
                        </div>
                    ) : (
                        <div className="form-group mb-3">
                            <label>Max Weight</label>
                            <input type="number" className="form-control form-control-sm" name="maxWeight" required />
                        </div>
                    )}

                    <div className="form-group mb-3">
                        <label>Discount(%)</label>
                        <input type="number" className="form-control form-control-sm" name="discount" required />
                    </div>

                    <div className="d-flex mt-2 justify-content-between ">
                        <button
                            type="button"
                            className="btn btn-warning btn-sm "
                            onClick={() => onCloseAddLabelModal()}
                            s>
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary btn-sm">
                            Add {loader}
                        </button>
                    </div>
                </form>
            </ModalContainer>

            {/* edit modal */}

            <ModalContainer hideActions open={showEditLabel} onClose={onCloseEditLabelModal} title="Edit Label Type">
                {message}
                <form onSubmit={updatePricing}>
                    <div className="form-group mb-3">
                        <label>Type</label>
                        <select
                            name="type"
                            id=""
                            className="form-control form-control-sm"
                            value={single.type}
                            onChange={(e) => setSingle({ ...single, type: e.target.value })}>
                            <option value="swift">swift</option>
                            <option value="aio.gg">aio.gg</option>
                            <option value="u5p5">U5P5</option>
                            <option value="tls">TLS</option>
                            <option value="genemporium">Gen Emporium</option>
                            <option value="bulkup3">Bulkup3</option>
                            <option value="royal_mail">royal_mail</option>
                        </select>
                    </div>

                    {single.type === 'swift' ? (
                        <div className="form-group mb-3">
                            <label>Name</label>
                            <select
                                name="name"
                                id=""
                                required
                                className="form-control form-control-sm"
                                value={single.name}
                                onChange={(e) => setSingle({ ...single, name: e.target.value })}>
                                <option value="" disabled selected hidden>
                                    select
                                </option>
                                {swiftLabelData?.map((e) => {
                                    return <option value={e.name}>{e.name}</option>;
                                })}
                            </select>
                        </div>
                    ) : (
                        <div className="form-group mb-3">
                            <label>Name</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                name="name"
                                required
                                value={single.name}
                                onChange={(e) => setSingle({ ...single, name: e.target.value })}
                            />
                        </div>
                    )}

                    {single.type === 'swift' ? (
                        <div className="form-group mb-3">
                            <label>UID</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                name="uid"
                                required
                                onChange={(e) => setSingle({ ...single, uid: e.target.value })}
                                value={
                                    single.type === 'swift'
                                        ? (single.uid = swiftLabelData
                                              ?.filter((e) => e.name === single.name)
                                              ?.map((e) => e.uuid.toString())[0])
                                        : single.uid
                                }
                            />
                        </div>
                    ) : lableTypeSwift === 'u5p5' ? (
                        <div className="form-group mb-3">
                            <label>UID</label>
                            <select
                                name="uid"
                                id=""
                                required
                                className="form-control form-control-sm"
                                value={single.uid}
                                onChange={(e) => setSingle({ ...single, uid: e.target.value })}>
                                <option value="" disabled selected hidden>
                                    select
                                </option>
                                <option value="priority">Priority</option>
                                <option value="express">Express</option>
                                <option value="firstclass">Firstclass</option>
                                <option value="signature">Signature</option>
                            </select>
                        </div>
                    ) : (
                        <div className="form-group mb-3">
                            <label>UID</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                name="uid"
                                required
                                value={single.uid}
                                onChange={(e) => setSingle({ ...single, uid: e.target.value })}
                            />
                        </div>
                    )}

                    {single.type === 'swift' ? (
                        <div className="form-group mb-3">
                            <label>Max Weight</label>
                            <input
                                type="number"
                                className="form-control form-control-sm"
                                name="maxWeight"
                                required
                                onChange={(e) => setSingle({ ...single, maxWeight: e.target.value })}
                                value={
                                    single.type === 'swift'
                                        ? (single.maxWeight = swiftLabelData
                                              ?.filter((e) => e.name === single.name)
                                              ?.map((e) => e.maxWeight.toString())[0])
                                        : single.maxWeight
                                }
                            />
                        </div>
                    ) : (
                        <div className="form-group mb-3">
                            <label>Max Weight</label>
                            <input
                                type="number"
                                className="form-control form-control-sm"
                                name="maxWeight"
                                required
                                value={single.maxWeight}
                                onChange={(e) => setSingle({ ...single, maxWeight: e.target.value })}
                            />
                        </div>
                    )}

                    <div className="form-group mb-3">
                        <label>Discount(%)</label>
                        <input
                            type="number"
                            className="form-control form-control-sm"
                            name="discount"
                            required
                            value={single.discount}
                            onChange={(e) => setSingle({ ...single, discount: e.target.value })}
                        />
                    </div>

                    <div className="d-flex mt-2 justify-content-between ">
                        <button
                            type="button"
                            className="btn btn-warning btn-sm "
                            onClick={() => onCloseEditLabelModal()}>
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary btn-sm">
                            Update {loader}
                        </button>
                    </div>
                </form>
            </ModalContainer>

            {/* delete label */}
            <ModalContainer
                hideActions
                open={showDeleteLabel}
                onClose={onCloseDeleteLabelModal}
                title="Delete Label Type">
                {message}
                <div className="text-center mt-0">
                    <p>Are you sure want to delete this label?</p>
                </div>

                <div className="d-flex justify-content-between ">
                    <button type="button" className="btn btn-default" onClick={() => onCloseDeleteLabelModal()}>
                        Close
                    </button>
                    <button className="btn btn-danger" onClick={() => DeleteLabelType(single._id)}>
                        Delete {loader}
                    </button>
                </div>
            </ModalContainer>
        </PageContainer>
    );
};

export default LabelPricing;
